export default "__VITE_ASSET__CPgYpOB0__"